setTimeout(function () {
  const app = window.document.getElementById('app')
  const loader = window.document.getElementById('loader')
  if (app) app.style.display = 'block'
  if (loader) loader.style.display = 'none'
}, 150)
